<template>
  <div id="chats">
    <Navbar current="Sessões" />
    <Sidebar />
    <Container col="col-12">
      <Header
        :headerClass="'mb-0'"
        :headerBodyClass="'pb-0 border-0'"
        :isSubHeader="false"
        title="Sessões"
        subtitle="Registro das sessões"
        :iconClass="'far fa-calendar-check text-primary'"
        :totalCount="total"
      >
        <template slot="button">
          <FilterPanel :fields="fields" :value="filters" :showChips="false" @apply="applyFilters" />
        </template>
      </Header>
      <div
        v-if="recurrencyIdFilter"
        class="alert alert-info d-flex align-items-center justify-content-between mt-3 mb-3"
      >
        <div>
          <i class="fa-solid fa-filter me-2"></i>
          Filtrando sessões da recorrência
          <strong>#{{ recurrencyIdFilter }}</strong>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          @click="clearRecurrencyFilter"
        >
          <i class="fa-solid fa-xmark me-1"></i> Limpar filtro
        </button>
      </div>

      <div v-if="Object.keys(filters).length" class="mt-4 mb-4">
        <FilterPanel :fields="fields" :value="filters" :showButton="false" @apply="applyFilters" />
      </div>
      <div v-else class="mb-4"></div>

      <AppointmentList
        :propFilters="listFilters"
        @totalItemsChanged="total = $event.total"
      />
    </Container>
  </div>
</template>
<script>
import AppointmentsController from "./AppointmentsController";
export default AppointmentsController;
</script>
